/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Result of pre check of parameters. All those checks will be provided one more time and more detailed while the workflow runs.
 * @export
 * @interface QuickInvestigationResultDto
 */
export interface QuickInvestigationResultDto {
    /**
     * If investigationStarted = true, all pre-checks are fine and the investigation started
     * @type {boolean}
     * @memberof QuickInvestigationResultDto
     */
    investigationStarted?: boolean;
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof QuickInvestigationResultDto
     */
    workflowInstanceId?: string;
    /**
     * What is wrong with lei
     * @type {string}
     * @memberof QuickInvestigationResultDto
     */
    leiReport?: string;
    /**
     * What is wrong with verification of uploaded file
     * @type {string}
     * @memberof QuickInvestigationResultDto
     */
    verificationFileReport?: string;
    /**
     * What is wrong with dns text report
     * @type {string}
     * @memberof QuickInvestigationResultDto
     */
    dnsTextReport?: string;
}

/**
 * Check if a given object implements the QuickInvestigationResultDto interface.
 */
export function instanceOfQuickInvestigationResultDto(value: object): boolean {
    return true;
}

export function QuickInvestigationResultDtoFromJSON(json: any): QuickInvestigationResultDto {
    return QuickInvestigationResultDtoFromJSONTyped(json, false);
}

export function QuickInvestigationResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuickInvestigationResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'investigationStarted': json['investigationStarted'] == null ? undefined : json['investigationStarted'],
        'workflowInstanceId': json['workflowInstanceId'] == null ? undefined : json['workflowInstanceId'],
        'leiReport': json['leiReport'] == null ? undefined : json['leiReport'],
        'verificationFileReport': json['verificationFileReport'] == null ? undefined : json['verificationFileReport'],
        'dnsTextReport': json['dnsTextReport'] == null ? undefined : json['dnsTextReport'],
    };
}

export function QuickInvestigationResultDtoToJSON(value?: QuickInvestigationResultDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'investigationStarted': value['investigationStarted'],
        'workflowInstanceId': value['workflowInstanceId'],
        'leiReport': value['leiReport'],
        'verificationFileReport': value['verificationFileReport'],
        'dnsTextReport': value['dnsTextReport'],
    };
}

